import request from '@/utils/request'

// 获取个人信息
export function fetchUserInfo(query) {
  return request({
    url: '/api/v1/userinfo',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}

// 编辑个人信息
export function postUserInfo(data) {
  return request({
    url: '/api/v1/usersimpleinfo',
    baseURL: 'other',
    method: 'put',
    data
  })
}

// 编辑用户注册
export function EditUser(data) {
  return request({
    url: `/api/v1/userinfo`,
    baseURL: 'other',
    // url: '/api/v1/station/userinfo',
    method: 'put',
    data
  })
}

// 修改手机号，特别是微信第三方登陆后需要修改关联微信号
export function editPhone(data) {
  return request({
    url: `/api/v1/phone?phone=${data.phone}`,
    baseURL: 'other',
    method: 'put',
    data
  })
}

// 获取民族
export function getNationList(query) {
  return request({
    baseURL: 'other',
    url: `/api/v1/consts?parentSortId=1`,
    method: 'get',
    params: query
  })
}
